import React, { PureComponent } from "react";


const AxisLabel = class extends PureComponent {

    render(){
        let {x,y, label} = this.props;
        return (
            <g>
                <text x={x} y={y} dominantBaseline="middle" textAnchor="end" fontSize="12">{label}</text>
            </g>
            
        )
    }

}

export default AxisLabel